import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useId, useRef, useState } from 'react';
import HelpBubble, {} from '@helsenorge/designsystem-react/components/HelpBubble';
import HelpExpanderInline, {} from '@helsenorge/designsystem-react/components/HelpExpanderInline';
import { getPath } from '@helsenorge/framework-utils/hn-page';
import { Projects, useResources } from '../../../resources';
import { HNeventHelpBubble } from '../../events';
import OpenHjelpeskuff from '../../hjelpeskuff/open-hjelpeskuff';
import { useHelpBubbleEvent } from '../../store/hooks/useHelpBubbleEvent';
import useHjelpetekstById from '../../store/hooks/useHjelpetekstById';
import { trackProsesshjelp } from '../../utils/analytics';
import HelpText from '../helpexpanderinline/helptext';
/**
 * Obs! Skal ikke brukes direkte i vertikalene.
 * Generisk trigger med mulighet for HelpBubble/HelpExpanderInline som også kan åpne hjelpeskuffen med spesifikk hjelpetekst for en tjeneste.
 *
 */
function GenericTrigger(props) {
    const { tjenesteNavn = getPath(), useCustomEvent, hjelpetekstId, triggerComponent: TriggerComponent, triggerProps } = props;
    const helpBubbleId = useId();
    const controllerRef = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const { hjelpetekst, openHjelpeskuff } = useHjelpetekstById(tjenesteNavn, hjelpetekstId, useCustomEvent);
    const resources = useResources(Projects.FRAMEWORK);
    useHelpBubbleEvent(event => {
        // Lukk hjelpeboblen hvis en annen hjelpeboble åpnes
        if (helpBubbleId !== event.detail.helpBubbleId && props.variant === 'bubble') {
            setExpanded(false);
        }
    });
    if (!hjelpetekst) {
        return null;
    }
    const handleShowHelpInContext = (e) => {
        setExpanded(!expanded);
        if (triggerProps?.onClick) {
            triggerProps.onClick(e);
        }
        HNeventHelpBubble(helpBubbleId);
    };
    const handleOpenHjelpeskuff = (e) => {
        openHjelpeskuff();
        if (triggerProps?.onClick) {
            triggerProps.onClick(e);
        }
    };
    const hasHjelpeskuff = !!hjelpetekst.hjelpeskuffTittel && !!hjelpetekst.hjelpeskuffTekst;
    const hasBubble = !!hjelpetekst.kontekstTekst && props.variant === 'bubble';
    // Trigger som kun åpner hjelpeskuffen, ingen kontekstuell hjelpetekst
    if (hasHjelpeskuff && (!props.variant || !hjelpetekst.kontekstTekst)) {
        return _jsx(TriggerComponent, { ...triggerProps, onClick: handleOpenHjelpeskuff });
    }
    // Trigger med kontekstuell hjelpetekst og mulighet for å åpne hjelpeskuffen
    if (!hjelpetekst.kontekstTekst) {
        return null;
    }
    const shouldHaveAriaHaspopup = hasHjelpeskuff || hasBubble;
    const linkText = hasBubble
        ? props.helpBubbleProps?.linkText || (hasHjelpeskuff && hjelpetekst.visHjelpeskuffTekst) || resources?.visHjelpeskuffTekst
        : undefined;
    const handleLinkClick = () => {
        if (!hasBubble) {
            return;
        }
        if (hasHjelpeskuff) {
            trackProsesshjelp('OpenHjelpeskuff', linkText);
            openHjelpeskuff();
        }
        if (props.helpBubbleProps?.onLinkClick) {
            props.helpBubbleProps?.onLinkClick();
        }
    };
    const handleBubbleClose = () => {
        if (!hasBubble) {
            return;
        }
        setExpanded(false);
        if (props.helpBubbleProps?.onClose) {
            props.helpBubbleProps.onClose();
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(TriggerComponent, { ...triggerProps, "aria-haspopup": shouldHaveAriaHaspopup ? 'dialog' : undefined, "aria-expanded": expanded, onClick: handleShowHelpInContext, ref: controllerRef }), hasBubble && (_jsx(HelpBubble, { ...props.helpBubbleProps, resources: {
                    ariaLabel: hjelpetekst.kontekstTittel,
                }, controllerRef: controllerRef, linkText: linkText, onLinkClick: handleLinkClick, showBubble: expanded, onClose: handleBubbleClose, children: _jsx(HelpText, { value: hjelpetekst.kontekstTekst }) })), props.variant === 'expander' && hjelpetekst.kontekstTekst && expanded && (_jsxs(HelpExpanderInline, { ...props.helpExpanderInlineProps, controllerRef: controllerRef, expanded: expanded, children: [_jsx(HelpText, { value: hjelpetekst.kontekstTekst }), hasHjelpeskuff && _jsx(OpenHjelpeskuff, { onClick: openHjelpeskuff, children: hjelpetekst?.visHjelpeskuffTekst })] }))] }));
}
export default GenericTrigger;
